/**
 * @file Arrow.jsx
 * @exports Arrow
 */
import React from 'react'

const Arrow = function Arrow ({ style }) {
  return (
    <svg width='13' height='11' viewBox='0 0 13 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.5 11L0.437821 0.499999L12.5622 0.499998L6.5 11Z' fill='#284047' />
    </svg>
  )
}

export default Arrow
